import styled from 'styled-components';

export const AddOnsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 16px 0;
	width: 100%;
`;

export const AddonRow = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	background: ${({ theme }) => theme.colors.white};
	border: 1px solid ${({ theme }) => theme.colors.grey19};
	border-radius: 12px;
	padding: 12px 16px;
	max-width: 500px;
	@media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		max-width: 100%;
	}
`;

export const PositionBadge = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 28px;
	height: 28px;
	border-radius: 14px;
	background: ${({ theme }) => theme.colors.punchupBackground};
	color: ${({ theme }) => theme.colors.lightGrey10};
	font-size: 13px;
	font-weight: 600;
`;

export const Thumbnail = styled.img`
	width: 40px;
	height: 40px;
	object-fit: cover;
	border-radius: 8px;
	flex-shrink: 0;
`;

export const ThumbnailPlaceholder = styled.div`
	width: 40px;
	height: 40px;
	border-radius: 8px;
	background: ${({ theme }) => theme.colors.punchupBackground};
	flex-shrink: 0;
`;

export const AddonInfo = styled.div`
	flex: 1;
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 2px;
`;

export const AddonName = styled.div`
	font-size: 15px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export const AddonPrice = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.colors.lightGrey10};
`;

export const ArrowButtons = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const ArrowButton = styled.button<{ disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 22px;
	border: 1px solid ${({ theme }) => theme.colors.grey19};
	border-radius: 6px;
	background: ${({ theme }) => theme.colors.white};
	color: ${({ theme, disabled }) => (disabled ? theme.colors.grey19 : theme.colors.lightGrey10)};
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	padding: 0;

	&:hover:not(:disabled) {
		background: ${({ theme }) => theme.colors.punchupBackground};
	}
`;

export const EmptyState = styled.div`
	padding: 24px;
	color: ${({ theme }) => theme.colors.lightGrey10};
	width: 100%;
	text-align: center;
	font-size: 14px;
`;
